import { render } from "./InsuranceNotification.vue?vue&type=template&id=7bff7894&ts=true"
import script from "./InsuranceNotification.vue?vue&type=script&lang=ts"
export * from "./InsuranceNotification.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__